import { Configuration, PublicClientApplication, LogLevel } from '@azure/msal-browser';

const getEnvConfig = () => {
  if (typeof window !== 'undefined' && window.ENV?.AZURE_AD) {
    return window.ENV.AZURE_AD;
  }
  return {
    CLIENT_ID: import.meta.env.VITE_MSAL_CLIENT_ID,
    TENANT_ID: import.meta.env.VITE_MSAL_TENANT_ID,
    REDIRECT_URI: import.meta.env.VITE_MSAL_REDIRECT_URI,
    LOGOUT_REDIRECT_URI: import.meta.env.VITE_MSAL_POST_LOGOUT_REDIRECT_URI,
    API_SCOPE: import.meta.env.VITE_MSAL_SCOPES,
  };
};

const envConfig = getEnvConfig();

export const msalConfig: Configuration = {
  auth: {
    clientId: envConfig.CLIENT_ID,
    authority: `https://login.microsoftonline.com/${envConfig.TENANT_ID}`,
    redirectUri: envConfig.REDIRECT_URI,
    postLogoutRedirectUri: envConfig.REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case 0:
            console.error(message);
            return;
          case 1:
            console.warn(message);
            return;
          case 2:
            console.info(message);
            return;
          case 3:
            console.debug(message);
            return;
        }
      },
      logLevel: LogLevel.Error,
    },
  },
};

export const loginRequest = {
  scopes: [envConfig.API_SCOPE],
};

export const msalInstance = new PublicClientApplication(msalConfig);
